import AbstractPartnerModel from './AbstractPartnerModel';
import { RenderNameProps }  from '@widesk-ui/mixins/ApiModelRenderName';
import { computed }         from 'mobx';
import appStore             from '@/stores/appStore';
import { Translatable }     from '@widesk-core/decorators/translatable';
import doc                  from '@widesk-core/decorators/doc';

@doc.translatable({ content: true })
class PartnerModel extends AbstractPartnerModel {
	public renderName(props?: RenderNameProps<this> & PartnerNameProps) {
		return super.renderName(props);
	}

	@computed get contentToPublish() {
		return appStore.collContentToPublish
			.find(m => m.objectUrn === this.urn) || undefined;
	}

	get isPublishScheduled() {
		return this.contentToPublish?.contentToPublishStatus.reference === 'ENABLED';
	}
}

interface PartnerModel extends Translatable<{ content: true }> {
}

export default PartnerModel;
